import { useState } from "react";
import contactImg from "../assets/contact.png";

export default function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: ""
    });
    const [status, setStatus] = useState({ loading: false, message: "", type: "" });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ loading: true, message: "Sending...", type: "info" });

        const data = new FormData();
        data.append("name", formData.name);
        data.append("email", formData.email);
        data.append("message", formData.message);

        try {
            const response = await fetch("https://wamglamz.com/wambackend/send_mail.php", {
                method: "POST",
                body: data,
            });

            if (response.ok) {
                setStatus({ loading: false, message: "Inquiry sent successfully!", type: "success" });
                setFormData({ name: "", email: "", message: "" }); // Reset form
            } else {
                setStatus({ loading: false, message: "Failed to send inquiry. Please try again.", type: "error" });
            }
        } catch (error) {
            console.error("Mail Error:", error);
            setStatus({ loading: false, message: "Network error occurred. Please try again.", type: "error" });
        }
    };

    return (
        <section className="py-20 bg-[#F5F9FF]">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                {/* MAIN CONTAINER */}
                <div className="relative rounded-[20px] overflow-hidden flex flex-col md:flex-row bg-white">
                    
                    {/* LEFT FORM */}
                    <div className="w-full md:w-1/2 p-10 md:p-14">
                        <h2 className="text-[36px] font-bold text-[#2563EB]">
                            Have a Query?
                        </h2>
                        <p className="text-gray-500 mt-2 text-[16px]">
                            Our concierge team is here to help you craft your perfect transformation journey.
                        </p>

                        {/* FORM */}
                        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                            {/* ROW */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="text-[14] text-gray-600">Full Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        placeholder="Jane Doe"
                                        className="w-full mt-2 bg-[#EAF2FF] px-4 py-3 rounded-xl outline-none text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="text-[14] text-gray-600">Email Address</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        placeholder="jane@example.com"
                                        className="w-full mt-2 bg-[#EAF2FF] px-4 py-3 rounded-xl outline-none text-sm"
                                    />
                                </div>
                            </div>

                            {/* MESSAGE */}
                            <div>
                                <label className="text-[14] text-gray-600">Your Message</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    placeholder="How can we help you today?"
                                    rows="4"
                                    className="w-full mt-2 bg-[#EAF2FF] px-4 py-3 rounded-xl outline-none text-sm"
                                ></textarea>
                            </div>

                            {/* STATUS MESSAGE */}
                            {status.message && (
                                <p className={`text-sm ${status.type === 'error' ? 'text-red-500' : 'text-green-600'}`}>
                                    {status.message}
                                </p>
                            )}

                            {/* BUTTON */}
                            <button 
                                type="submit" 
                                disabled={status.loading}
                                className={`w-full mt-4 text-white py-3 rounded-xl font-semibold transition-opacity ${
                                    status.loading 
                                    ? "bg-gray-400 cursor-not-allowed" 
                                    : "bg-gradient-to-r from-[#0A3FB6] to-[#2FB4FF] hover:opacity-90"
                                }`}
                            >
                                {status.loading ? "Sending..." : "Send Inquiry"}
                            </button>
                        </form>
                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="relative w-full md:w-1/2">
                        <img
                            src={contactImg}
                            alt="Contact Us"
                            className="w-full h-full object-cover"
                        />

                        {/* FADE OVERLAY (IMPORTANT) */}
                        <div className="absolute inset-0 bg-gradient-to-r from-white/100 via-white/10 to-transparent"></div>
                    </div>
                </div>
            </div>
        </section>
    );
}